import { Pipe, PipeTransform } from '@angular/core';

import * as numeral from 'numeral';

/*
 * Formats numbers
 * Takes a number and formats it according to numeral.js
 * Usage:
 *   value | shortNumber
 * Example:
 *   {{ 15000.00 | numberFormatter:'0,0' }}
 *   formats to: 15,000
 */
@Pipe({ name: 'numberFormatter' })
export class NumberFormatterPipe implements PipeTransform {
  transform(value: number, formatString: string): string {
    const output: any = numeral(value).format(formatString);

    return output;
  }
}
